import { render, staticRenderFns } from "./TomaMoneyInput.vue?vue&type=template&id=033c8db1"
import script from "./TomaMoneyInput.vue?vue&type=script&lang=js"
export * from "./TomaMoneyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports